/* eslint-disable no-param-reassign */
import { inlineSvg } from './inlineSvg';

export async function loadSvgFile({ src }) {
    // eslint-disable-next-line
    const url = require(`@/assets/print/images/${src}`);
    const xmlDoc = await d3.xml(url);
    return xmlDoc.documentElement;
}

// const { chartFont } = pdfStyle;
// Add styles here if problem inlining
const excludedStyles = ['font-family'];

export function createStyledClone({ selector, svg }) {
    svg = svg || document.querySelector(selector);
    if (!svg) {
        return null;
    }
    const inlined = inlineSvg(svg, false, excludedStyles);
    // d3.select(inlined).style('font-family', chartFont.family);
    return inlined;
}
